import { mapMutations, mapState } from "vuex";
export const myMixins = {
    data() {
        return {
            webAppId: "",
        };
    },
    computed: {
        ...mapState(["hasLogin", "userInfo", "openId", "config", "follow"]),
    },
    created() {
        this.getWxConfig();
    },
    methods: {
        ...mapMutations([
            "login",
            "setOpenId",
            "setConfig",
            "setOrgInfo",
            "setdomain",
            "setFollow",
        ]),
        getWxConfig() {
            this.$http.request(this.$http.pathMap.wxConfig).then((res) => {
                this.webAppId = res.data.appId;
                localStorage.setItem("appId", res.data.appId);
                localStorage.setItem("shopTitle", res.data.baseInfoName || "");
                this.setdomain(res.data.domain);
                const changeFavicon = (link) => {
                    let $favicon = document.querySelector('link[rel="icon"]');

                    if ($favicon !== null) {
                        $favicon.href = link;
                    } else {
                        $favicon = document.createElement("link");
                        $favicon.rel = "icon";
                        $favicon.href = link;
                        document.head.appendChild($favicon);
                    }
                };
                const icon = res.data.baseInfoLogo; // 图片地址
                changeFavicon(icon); // 动态修改网站图标
                const title = res.data.baseInfoName; // 网站标题
                document.title = title; // 动态修改网站标题
                let token = localStorage.getItem("token");
                // token =
                //   "eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJXZUNoYXROYW1lIiwidXNlcklkIjo2MjQsInRlbmFudElkIjoxLCJjdXJyZW50UmVhbE5hbWUiOiJXZUNoYXROYW1lIiwiY3VycmVudERlcHRJZCI6MCwidXNlclNjb3BlIjoibWFsbF9hcGkiLCJleHAiOjE2Njk3NDA4MDJ9.zQfxdEbed4mlSEpnkF7CMkaiXxZMyD-_Vc3rL45JCtvgvEO9o6s7gfVLeaYXAB5w2n_bEWBrPwoKskxvIAZ-LW-zNcbWrIBSg85L5vsVm3XslElajPNB8-OMSiUCpZQvpjg31e2oEwOdcRGVkLSxFJAuOM16XFrykDNj3pG5VQI";
                if (!token) {
                    this.h5WeChatAuth(this.requestOpenId.bind(this));
                } else {
                    this.getOrgSetting();
                    this.getUserInfo();
                    // this.$http
                    //     .getJsSdkConfig()
                    //     .then((res) => {
                    //         console.log("jsSdk签名成功");
                    //     })
                    //     .catch((err) => {
                    //         console.log(err);
                    //     });
                }
            });
        },
        getOrgSetting() {
            this.$http.request(this.$http.pathMap.orgInfo).then((res) => {
                const config = res.data.template;
                this.setConfig(config);
                this.setOrgInfo(res.data);
                localStorage.setItem("name", res.data.name || "");
                localStorage.setItem("shareTitle", res.data.shareTitle || "");
                localStorage.setItem("desc", res.data.shareDescription || "");
                // #ifdef H5
                document.body.style.setProperty(
                    "--theme-font-color",
                    config.theme.fontColor
                );
                // #endif
            });
        },
        h5WeChatAuth(callback) {
            const href = window.location.href;
            let paramObj = {};
            let needGo = false;
            if (href.indexOf("?") > -1) {
                const params = href.substr(href.indexOf("?") + 1, href.length);
                let paramArr = [];
                if (href.indexOf("&") > -1) {
                    paramArr = params.split("&");
                }
                for (const param of paramArr) {
                    const a = param.split("=");
                    paramObj[a[0]] = a.length === 2 ? a[1] : "";
                }
            }
            // 判断是否有code
            if (!paramObj.code) {
                needGo = true;
            } else {
                this.clearCode();
                callback(paramObj.code);
            }
            //获取code
            if (needGo) {
                const appId = this.webAppId;
                const url = encodeURIComponent(href);
                // let url = "https://b.zhifu88.cn/";
                const wxAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
                window.location.href = wxAuthUrl;
            }
        },
        requestOpenId(code) {
            let params = {
                code,
            };
            let query = this.$route.query;
            if (query.userId) {
                params.recommender = query.userId;
            }
            const url = this.$http.pathMap.weChatLogin;
            this.$http.request(url, "get", params).then(async (res) => {
                if (res.data) {
                    localStorage.setItem("token", res.data.token);
                    await this.getOrgSetting();
                    await this.getUserInfo();
                }
            });
        },
        clearCode() {
            //清除链接中的code
            let href = window.location.href;
            if (href.indexOf("?") > -1 && href.indexOf("#") > -1) {
                let r = href.slice(href.indexOf("?"), href.indexOf("#"));
                let e = href.replace(r, "");
                history.replaceState("", "", e);
            }
        },
        toLogin() {
            this.$router.push({
                path: "/pages/WechatAuth",
                query: {
                    redirectUrl: this.$route.fullPath || "/",
                },
            });
        },
        getUserInfo() {
            this.$http
                .request(this.$http.pathMap.userInfo, "post")
                .then(async (res) => {
                    if (res.data) {
                        await this.login(res.data);
                        let follow = "";
                        if (res.data.follow === null) {
                            follow = "";
                        }
                        follow = res.data.follow;
                        this.setFollow(follow);
                        localStorage.setItem("userId", res.data.id);
                        localStorage.setItem("tenantId", res.data.tenantId);
                        localStorage.setItem('avatar', res.data.avatar)
                        localStorage.setItem("logo", res.data.logo || "");
                        if (res.data.avatar == null || res.data.avatar == '' || res.data.avatar == undefined || res.data.avatar == 'null') {
                            this.toLogin();
                        }
                    } else {
                        localStorage.removeItem("token");
                        let href = window.location.href;
                        if (href.indexOf("?") > -1) {
                            href = href.substring(0, href.indexOf("?"));
                        }
                        window.location.replace(href);
                        window.location.reload();
                    }
                });
        },
    }
}
